import configuracionesService from '../services/configuraciones.service';

export default {
  data() {
    return {
      configuraciones: null,
    };
  },
  methods: {
    async obtenerConfiguraciones(universidadId) {
      if (!universidadId) {
        return;
      }

      return configuracionesService
        .findByUniversidadId(universidadId)
        .then((response) => {
          const data = response?.data;
          const datos = data?.datos;
          const mensaje = data?.mensaje;

          this.configuraciones = datos;
          this.$notify({
            group: 'notifications',
            title: 'Configuraciones',
            text: mensaje || 'Configuraciones cargadas correctamente',
            type: 'success',
          });
        })
        .catch((error) => {
          const mensaje = error?.response?.data?.mensaje || 'Error al cargar las configuraciones';

          this.$notify({
            group: 'notifications',
            title: 'Configuraciones',
            text: mensaje,
            type: 'error',
          });
        });
    },
  },
};
